import { CalendarCheck, SearchCheck, FileText, ShieldCheck } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const STEPS = [
  {
    icon: CalendarCheck,
    title: "Book Appointment",
    desc: "Call, WhatsApp or book online. Same-day slots available across Hyderabad.",
    slug: "book",
  },
  {
    icon: SearchCheck,
    title: "Vehicle Inspection",
    desc: "A 60–90 minute on-site inspection covering every mechanical and electronic system.",
    slug: "inspect",
  },
  {
    icon: FileText,
    title: "Digital Report",
    desc: "A detailed PDF report with photos, fault codes and paint thickness readings.",
    slug: "report",
  },
  {
    icon: ShieldCheck,
    title: "Buy With Confidence",
    desc: "Negotiate the right price — or walk away — knowing exactly what you're buying.",
    slug: "confidence",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-28 md:py-36">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter index="04" label="Inspection Process" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-6xl">
          From booking to report
          <span className="block text-white/40">in a single day.</span>
        </h2>
      </Reveal>

      <div className="relative mt-20">
        <div className="absolute left-0 right-0 top-8 hidden border-t border-dashed border-white/15 lg:block" />
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((step, i) => (
            <Reveal key={step.slug} delay={0.1 * i}>
              <div data-testid={`process-step-${step.slug}`} className="group relative">
                <div className="flex items-center gap-4">
                  <span className="relative z-10 grid h-16 w-16 place-items-center rounded-2xl border border-gold/30 bg-[#0c0c0c] text-gold transition-[transform,border-color] duration-500 group-hover:scale-110 group-hover:border-gold">
                    <step.icon className="h-7 w-7" strokeWidth={1.7} />
                  </span>
                  <span className="font-heading text-6xl font-extrabold tracking-tighter text-white/10 transition-colors duration-500 group-hover:text-gold/25">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-extrabold tracking-tight text-white">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-white/55">
                  {step.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
